import { useQuery } from '@tanstack/react-query';
import { IUpdateDisciplineStatusRequest } from 'Data/interfaces/Obra/IUpdateDisciplineStatusRequest';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import ObrasApi from 'Data/Obras.api';
import { useEffect } from 'react';
import toastHandler from 'Utils/toastHandler';
import { openError } from 'Utils/Messages';
import { NavigateFunction } from 'react-router';

interface IUseQueryUniqueObraProps extends IUpdateDisciplineStatusRequest {
  navigate: NavigateFunction;
}

export const useQueryUniqueObra = ({ csId, ignoreCache, navigate }: IUseQueryUniqueObraProps) => {
         const { data, refetch, isLoading, isFetching, error } = useQuery({
           queryKey: [OBRA_QUERY_KEY, Number(csId)],
           staleTime: 60 * 5 * 1000, // 5 minutes
           queryFn: async () => {
             const response = await ObrasApi.getConstructionSite({
               csId,
               ignoreCache,
             });
             response.data.data.SharedUsers = [
               ...response.data.data.SharedUsers.filter((sharedUser: any) => {
                 return sharedUser.User.CurrentRoleFk !== 1;
               }),
             ];
             return response.data.data;
           },
           enabled: !!csId,
         });

         useEffect(() => {
           if (!data && error && !isLoading && !isFetching) {
             console.log(error);
             // const errorMsg = error?.errors ? error?.errors[0].Message : openError('disciplinas');
             toastHandler.handler({
               description: openError('disciplinas'),
               icon: 'error',
               title: '',
             });
             navigate('/obras');
           }
         }, [data, error, isLoading, isFetching, navigate]);

         return {
           data: data ?? null,
           refetch,
           isLoading,
           isFetching,
           error,
         };
       };
